import Model from './Model';

export default class CarOwner extends Model {
  baseURL() {
    return '';
  }

  resource() {
    return 'car-owners';
  }
}
